<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title title">
      <i class="far fa-check-circle"></i> {{ "TITLE.IDENTITY-VALIDATION" | translate }}</h4>
  </div>
  <div class="modal-body">
    <form autocomplete="off" [formGroup]="identityForm">
      <div class="row">
        <div class="col-md-6" *ngIf="isNeed4identityValidation('checkDigit')">
          <label for="checkDigit" class="col-form-label">{{ "LABEL.CHECK-DIGIT" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="number"
                   class="form-control"
                   id="checkDigit"
                   placeholder="3"
                   formControlName="checkDigit"
                   [(ngModel)]="checkDigit">
          </div>
          <small *ngIf="isInvalidControl('checkDigit')"
                 class="text-danger">
            {{getErrorMessageBy('checkDigit')}}
          </small>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('lastName')">
          <label for="lastName" class="col-form-label">{{ "LABEL.LAST-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="text"
                   class="form-control"
                   id="lastName"
                   placeholder="{{ 'MESSAGE.FATHERS-LAST-NAME-ARE-REQUIRED' | translate }}"
                   formControlName="lastName"
                   [(ngModel)]="lastName">
          </div>
          <small *ngIf="isInvalidControl('lastName')"
                 class="text-danger">
            {{getErrorMessageBy('lastName')}}
          </small>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('lastName2')">
          <label for="lastName2" class="col-form-label">{{ "LABEL.LAST-NAME2" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="text"
                   class="form-control"
                   id="lastName2"
                   placeholder="{{ 'MESSAGE.MOTHERS-LAST-NAME-ARE-REQUIRED' | translate }}"
                   formControlName="lastName2"
                   [(ngModel)]="lastName2">
          </div>
          <small *ngIf="isInvalidControl('lastName2')"
                 class="text-danger">
            {{getErrorMessageBy('lastName2')}}
          </small>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('name')">
          <label for="name" class="col-form-label">{{ "LABEL.NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="text"
                   class="form-control"
                   id="name"
                   placeholder="{{ 'MESSAGE.NAME-IS-REQUIRED' | translate }}"
                   formControlName="name"
                   [(ngModel)]="name">
          </div>
          <small *ngIf="isInvalidControl('name')"
                 class="text-danger">
            {{getErrorMessageBy('name')}}
          </small>
        </div>
<!--        <div class="col-md-6" *ngIf="isNeed4identityValidation('birthLocation')">
          <label for="birthLocation" class="col-form-label">{{ "LABEL.BIRTH-LOCATION" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="number"
                   class="form-control"
                   id="birthLocation"
                   placeholder="123456"
                   formControlName="birthLocation"
                   [(ngModel)]="birthLocation">
          </div>
          <small *ngIf="isInvalidControl('birthLocation')"
                 class="text-danger">
            {{getErrorMessageBy('birthLocation')}}
          </small>
        </div>-->
        <div class="col-md-6" *ngIf="isNeed4identityValidation('civilStatus')">
          <label for="civilStatus" class="col-form-label">{{ "LABEL.CIVIL-STATUS" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <select class="form-control"
                    id="civilStatus"
                    formControlName="civilStatus"
                    [(ngModel)]="civilStatus">
              <option [value]="single">{{ "LABEL.SINGLE" | translate }}</option>
              <option [value]="married">{{ "LABEL.MARRIED" | translate }}</option>
              <option [value]="widower">{{ "LABEL.WIDOWER" | translate }}</option>
              <option [value]="divorced">{{ "LABEL.DIVORCED" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('gender')">
          <label for="gender" class="col-form-label">{{ "LABEL.GENDER" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <select class="form-control"
                    id="gender"
                    formControlName="gender"
                    [(ngModel)]="gender">
              <option [value]="male">{{ "LABEL.MALE" | translate }}</option>
              <option [value]="female">{{ "LABEL.FEMALE" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('birthDate')">
          <label for="birthDate" class="col-form-label">{{ "LABEL.BIRTH-DATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input id="birthDate"
                   class="form-control"
                   name="birthDate"
                   ngbDatepicker #d="ngbDatepicker"
                   placeholder="2020-01-01"
                   [minDate]="{year: 1930, month:1, day: 1}"
                   formControlName="birthDate"
                   [(ngModel)]="birthDate">
            <div class="input-group-append">
              <button class="btn btn-outline-success" (click)="d.toggle()" type="button">
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
          <small *ngIf="isInvalidControl('birthDate')"
                 class="text-danger">
            {{getErrorMessageBy('birthDate')}}
          </small>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('fatherName')">
          <label for="fatherName" class="col-form-label">{{ "LABEL.FATHER-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="text"
                   class="form-control"
                   id="fatherName"
                   placeholder="{{ 'MESSAGE.ENTER-FATHER-NAME' | translate }}"
                   formControlName="fatherName"
                   [(ngModel)]="fatherName">
          </div>
          <small *ngIf="isInvalidControl('fatherName')"
                 class="text-danger">
            {{getErrorMessageBy('fatherName')}}
          </small>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('motherName')">
          <label for="motherName" class="col-form-label">{{ "LABEL.MOTHER-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input type="text"
                   class="form-control"
                   id="motherName"
                   placeholder="{{ 'MESSAGE.ENTER-MOTHER-NAME' | translate }}"
                   formControlName="motherName"
                   [(ngModel)]="motherName">
          </div>
          <small *ngIf="isInvalidControl('motherName')"
                 class="text-danger">
            {{getErrorMessageBy('motherName')}}
          </small>
        </div>
        <div class="col-md-6" *ngIf="isNeed4identityValidation('issueDate')">
          <label for="issueDate" class="col-form-label">{{ "LABEL.ISSUE-DATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-address-card"></i></div>
            </div>
            <input id="issueDate"
                   class="form-control"
                   name="issueDate"
                   ngbDatepicker #d="ngbDatepicker"
                   placeholder="2020-01-01"
                   [minDate]="{year: 1930, month:1, day: 1}"
                   formControlName="issueDate"
                   [(ngModel)]="issueDate">
            <div class="input-group-append">
              <button class="btn btn-outline-success" (click)="d.toggle()" type="button">
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
          <small *ngIf="isInvalidControl('issueDate')"
                 class="text-danger">
            {{getErrorMessageBy('issueDate')}}
          </small>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-danger"
            *ngIf="!isPublic"
            (click)="cancel()"><i
      class="fa fa-times"></i> {{"BUTTON.CANCEL" | translate}}</button>
    <button class="btn btn-success" (click)="accept()"><i class="fa fa-bookmark"></i> {{"BUTTON.ACCEPT" | translate}}
    </button>
  </div>
</div>
